import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/common/alipay.png';
import _imports_1 from '@/assets/icon/icon_unchecked.png';
import _imports_2 from '@/assets/icon/icon_checked.png';
import _imports_3 from '@/assets/img/common/wechat_pay.png';
const _withScopeId = n => (_pushScopeId("data-v-e858185a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "lorderPageWrapper" };
const _hoisted_2 = { class: "orderMsg white-bg m-b20 m-t20 p-lr20 p-tb24" };
const _hoisted_3 = { class: "flexBox h-44 m-b16" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "orderText gray-6 font-w500" }, "订单编号：", -1));
const _hoisted_5 = { class: "font-w500" };
const _hoisted_6 = { class: "flexBox h-44 m-b16" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "gray-6 font-w500" }, "下单时间：", -1));
const _hoisted_8 = { class: "font-w500" };
const _hoisted_9 = { class: "flexBox h-44 m-b16" };
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "orderText gray-6 font-w500" }, "订单归属人：", -1));
const _hoisted_11 = { class: "font-w500" };
const _hoisted_12 = { class: "flexBox h-44" };
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "gray-6 font-w500" }, "手机号：", -1));
const _hoisted_14 = { class: "font-w500" };
const _hoisted_15 = { class: "courseImg" };
const _hoisted_16 = ["src"];
const _hoisted_17 = { class: "detailRight" };
const _hoisted_18 = { class: "courseName font-w500" };
const _hoisted_19 = { class: "flexBox" };
const _hoisted_20 = { class: "priceNum font-w500" };
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "font-w500 gray-6" }, "x1", -1));
const _hoisted_22 = { class: "orderMsg white-bg m-b20 m-t20 p-lr20 p-tb24" };
const _hoisted_23 = { class: "flexBox h-44" };
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "orderText gray-6 font-w500" }, "总价：", -1));
const _hoisted_25 = { class: "font-w500" };
const _hoisted_26 = { class: "orderMsg white-bg m-b20 m-t20 p-lr20 p-tb24" };
const _hoisted_27 = { class: "flexBox m-b16 h-88" };
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "payIcon" }, [
    /*#__PURE__*/ _createElementVNode("img", {
        src: _imports_0,
        alt: ""
    })
], -1));
const _hoisted_29 = {
    class: "icon-check",
    src: _imports_1,
    alt: ""
};
const _hoisted_30 = {
    class: "icon-check",
    src: _imports_2,
    alt: ""
};
const _hoisted_31 = { class: "h-88 flexBox" };
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "payIcon" }, [
    /*#__PURE__*/ _createElementVNode("img", {
        src: _imports_3,
        alt: ""
    })
], -1));
const _hoisted_33 = {
    class: "icon-check",
    src: _imports_1,
    alt: ""
};
const _hoisted_34 = {
    class: "icon-check",
    src: _imports_2,
    alt: ""
};
const _hoisted_35 = { class: "bottomContent flexBox white-bg p-lr20 p-tb24" };
const _hoisted_36 = { class: "payPrice font-w500" };
const _hoisted_37 = ["onClick"];
const _hoisted_38 = { class: "backTip" };
const _hoisted_39 = { class: "tipContent" };
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("dt", null, "您的支付未完成是否继续支付？", -1));
const _hoisted_41 = ["onClick"];
const _hoisted_42 = ["onClick"];
import { getWechatCodeInfo } from '@/api/pay';
import { closeWebView } from '@/widget/index';
import { appPort, orderPay, prevPageView, wechatPort, getUserId } from '@/widget';
import { hostPath, payApi2 } from '@/public/utils/basePath';
import { getAlbumOrder } from '@/api/video';
import { useRouter, useRoute } from 'vue-router';
import { ref, getCurrentInstance, onMounted } from 'vue';
import Header from '@/components/common/Header.vue';
import { Toast } from 'vant';
import orderHeader from './orderHeader.vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        livePage: {
            type: String,
            default: ''
        }
    },
    setup(__props) {
        const props = __props;
        const { proxy: { $showLoading, $hideLoading } } = getCurrentInstance();
        const route = useRoute();
        const router = useRouter();
        const payType = ref('alipay');
        const orderId = String(route.params.orderId);
        const module = String(route.params.module);
        const orderInfo = ref({});
        const isApp = ref(appPort());
        const back = ref(false);
        const showBack = ref(false);
        const wechat = ref(wechatPort());
        let openId = localStorage.getItem('openId') || '';
        let code = String(route.query.code || '');
        let userId = getUserId();
        let albumId = ref(0);
        // 获取订单详情
        const getData = () => {
            getAlbumOrder(userId, orderId).then((res) => {
                if (res.code == 200) {
                    orderInfo.value = res.data;
                    albumId.value = orderInfo.value.products[0].productId;
                }
            });
        };
        if (wechat.value) {
            payType.value = 'wechat';
        }
        const checkType = (type) => {
            if (type === payType.value) {
                return;
            }
            if (isApp.value) {
                payType.value = type;
            }
            else {
                Toast(type == 'wechat' ? '当前环境不支持微信支付' : '当前环境不支持支付宝支付');
            }
        };
        const wechatAuth = () => {
            // 微信 code 校验
            if (wechatPort()) {
                let base = payApi2 + '/wechat/auth?redirectURI=';
                let redirectUrl = window.encodeURIComponent(location.href);
                window.location.replace(base + redirectUrl);
            }
        };
        if (!openId && !code && wechatPort()) {
            // 没有 openId 没有code 获取 openId
            wechatAuth();
        }
        // 订单支付
        const payOrder = () => {
            if (orderInfo.value.isPay) {
                Toast('订单已支付');
                return;
            }
            $showLoading();
            orderPay(payType.value, { module: module }, {
                returnUrl: `${hostPath}/learn/courseguide/album/${albumId.value}`,
                orderId
            }, (msg) => {
                if (!msg || msg == 'ok') {
                    paySuccess();
                }
                else {
                    Toast(msg);
                }
            })
                .then(() => {
                $hideLoading();
            })
                .catch((msg) => {
                $hideLoading();
                Toast(msg || '支付失败，请稍后重试');
            });
        };
        // 返回的页面
        const paySuccess = () => {
            // 支付成功 进入支付成功页
            if (isApp.value) {
                closeWebView();
            }
            else {
                location.assign(`${hostPath}/learn/courseguide/album/${albumId.value}`);
            }
        };
        const backFn = () => {
            if (back.value) {
                back.value = false;
                showBack.value = false;
                prevPage();
            }
            else if (showBack.value) {
                back.value = true;
            }
            else {
                back.value = false;
                showBack.value = false;
                prevPage();
            }
        };
        // 返回上一页
        const prevPage = () => {
            if (isApp.value) {
                prevPageView();
                return;
            }
            if (history.length > 2) {
                if (wechat.value) {
                    history.go(-2);
                }
                else {
                    history.go(-1);
                }
            }
            else {
                location.assign(hostPath);
            }
        };
        if (!!code && !openId) {
            //  获取 openId
            getWechatCodeInfo({
                code: code
            }).then(res => {
                if (res.code === 200) {
                    openId = res.data.openId;
                    localStorage.setItem('openId', openId);
                    // 去除链接中的code
                    router.replace({
                        path: route.path,
                        query: {
                            behalf: 1
                        }
                    });
                }
            });
        }
        const payAgain = () => {
            back.value = false;
        };
        if (isApp) {
            window.payCallback = () => {
                paySuccess();
            };
        }
        onMounted(() => {
            getData();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (!isApp.value && !__props.livePage)
                    ? (_openBlock(), _createBlock(Header, {
                        key: 0,
                        pageTitle: '确认订单',
                        showBack: true,
                        onBackFn: backFn
                    }))
                    : (Number(__props.livePage) == 1 && isApp.value)
                        ? (_openBlock(), _createBlock(orderHeader, { key: 1 }))
                        : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _hoisted_4,
                        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(orderId)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _hoisted_7,
                        _createElementVNode("div", _hoisted_8, _toDisplayString(orderInfo.value?.createTime), 1)
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                        _hoisted_10,
                        _createElementVNode("div", _hoisted_11, _toDisplayString(orderInfo.value?.userName), 1)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                        _hoisted_13,
                        _createElementVNode("div", _hoisted_14, _toDisplayString(orderInfo.value?.userPhone), 1)
                    ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderInfo.value?.products, (item, key) => {
                    return (_openBlock(), _createElementBlock("div", {
                        class: "orderMsg detailBox white-bg m-b20 m-t20 p-lr20 p-tb24",
                        key: key
                    }, [
                        _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("img", {
                                src: item.cover,
                                alt: ""
                            }, null, 8, _hoisted_16)
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("p", _hoisted_18, _toDisplayString(item.productName), 1),
                            _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("div", _hoisted_20, "￥" + _toDisplayString(item.price), 1),
                                _hoisted_21
                            ])
                        ])
                    ]));
                }), 128)),
                _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                        _hoisted_24,
                        _createElementVNode("div", _hoisted_25, "￥" + _toDisplayString(orderInfo.value?.price), 1)
                    ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                        _hoisted_28,
                        _createElementVNode("div", {
                            class: "radio",
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (checkType('alipay')), ["stop"]))
                        }, [
                            _withDirectives(_createElementVNode("img", _hoisted_29, null, 512), [
                                [_vShow, payType.value != 'alipay']
                            ]),
                            _withDirectives(_createElementVNode("img", _hoisted_30, null, 512), [
                                [_vShow, payType.value == 'alipay']
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                        _hoisted_32,
                        _createElementVNode("div", {
                            class: "radio",
                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (checkType('wechat')), ["stop"]))
                        }, [
                            _withDirectives(_createElementVNode("img", _hoisted_33, null, 512), [
                                [_vShow, payType.value !== 'wechat']
                            ]),
                            _withDirectives(_createElementVNode("img", _hoisted_34, null, 512), [
                                [_vShow, payType.value === 'wechat']
                            ])
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, "￥" + _toDisplayString(orderInfo.value?.price), 1),
                    _createElementVNode("div", {
                        class: _normalizeClass(["payButton", { disabled: !orderInfo.value.isPay }]),
                        onClick: _withModifiers(payOrder, ["stop"])
                    }, " 确认支付 ", 10, _hoisted_37)
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_38, [
                    _createElementVNode("dl", _hoisted_39, [
                        _hoisted_40,
                        _createElementVNode("dd", null, [
                            _createElementVNode("div", {
                                class: "cancel",
                                onClick: _withModifiers(backFn, ["stop"])
                            }, "我放弃了", 8, _hoisted_41),
                            _createElementVNode("div", {
                                class: "continue",
                                onClick: _withModifiers(payAgain, ["stop"])
                            }, "继续支付", 8, _hoisted_42)
                        ])
                    ])
                ], 512), [
                    [_vShow, back.value && showBack.value]
                ])
            ]));
        };
    }
});
